import React from 'react';
import { string } from 'prop-types';
import AUISpinner from '@ancert/aui-spinner';

const LoadingMask = ({ loadingText }) => (
  <div className="c-sii-loading">
    <AUISpinner size="lg" />
    {loadingText}
  </div>
);
LoadingMask.propTypes = {
  loadingText: string,
};
LoadingMask.defaultProps = {
  loadingText: 'Cargando',
};

export default LoadingMask;
